import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import BookmarksPage from "../../../components/BookComponents/BookMark";
import { DownloadHistoryList } from "../../../components/sharedcomponents/AudioDownloadHistory";
import { DownloadOutlined, HistoryOutlined } from "@ant-design/icons";
import { Tabs } from "antd";

export const UserLibraryPage = () => {
  return (
    <>
      <div>
        <TopBar displayType="logo" showNotification showProfileBtn></TopBar>
        {/* <BookmarksPage></BookmarksPage> */}
        {/* <DownloadBookList></DownloadBookList> */}
        {/* <DownloadHistoryList /> */}

        <div className="min-h-screen">
          <div className="w-full max-w-4xl mx-auto p-1">
            <Tabs
              defaultActiveKey="bookMark"
              items={[
                {
                  key: "bookMark",
                  label: (
                    <span className="text-gray-900 dark:text-stone-100">
                      <HistoryOutlined /> BookMark
                    </span>
                  ),
                  children: <BookmarksPage></BookmarksPage>,
                },
                {
                  key: "history",
                  label: (
                    <span className="text-gray-900 dark:text-stone-100">
                      <DownloadOutlined /> Downloads
                    </span>
                  ),
                  children: <DownloadHistoryList />,
                },
              ]}
            />
          </div>
        </div>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserLibraryPage;
